import React, { useState, useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { useNavigate } from "react-router-dom";
import nexapi from "../../services/api";
import { useAppContext } from "../../context/appcontext";
import { fetchSimpleLogin } from "../../../src/App";

const LogoutButton = () => {
  const { loggedinuser, setLoggedinuser } = useAppContext();
  const { instance } = useMsal();
  const navigate = useNavigate();
  const [isSimpleLogin, setIsSimpleLogin] = useState<boolean | null>(null);

  useEffect(() => {
    const checkLoginType = async () => {
      const result = await fetchSimpleLogin();
      setIsSimpleLogin(result);
    };
    checkLoginType();
  }, []);

  const handleLogout = async () => {
    const token = localStorage.getItem('access_token');
    const apiUrl = process.env.REACT_APP_API_URL + '/auth/logout'; 
    await nexapi.post(apiUrl + '?userId=' + loggedinuser.id + '&token=' + token);
    
    // Reset loggedinuser to default
    setLoggedinuser({
      id: '',
      displayName: '',
      mail: '',
      profileImage: 'https://i.pravatar.cc/40',
      roleId: [],
      Token: '',
      roles: '',
      companyId: ''
    });
    
    sessionStorage.clear();
    localStorage.clear();
    
    instance.logoutRedirect({
      postLogoutRedirectUri: window.location.origin,
    });
  };

  const logoutBypass = async () => {
    // Reset loggedinuser to default
    setLoggedinuser({
      id: '',
      displayName: '',
      mail: '',
      profileImage: 'https://i.pravatar.cc/40',
      roleId: [],
      Token: '',
      roles: '',
      companyId: ''
    });
    
    sessionStorage.clear();
    localStorage.clear();
    
    // Redirect to login page
    navigate('/login');
  };

  if (isSimpleLogin === null) {
    return (
      <button className="btn btn-danger" disabled>
        Loading...
      </button>
    );
  }

  return (
    <button 
      onClick={isSimpleLogin ? logoutBypass : handleLogout} 
      className="btn btn-danger"
    >
      Logout
    </button>
  );
};

export default LogoutButton;